export default {
    inject: ['appContainer'],
    props: ['parseProps', 'appMethods'],
    data () {
        return {
            loading: false
        }
    }
}
